import { render, staticRenderFns } from "./author-detail.vue?vue&type=template&id=2feb1720&"
import script from "./author-detail.vue?vue&type=script&lang=js&"
export * from "./author-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports